import { render, staticRenderFns } from "./informasi-pengguna.vue?vue&type=template&id=82948238"
import script from "./informasi-pengguna.vue?vue&type=script&lang=js"
export * from "./informasi-pengguna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports